import api from "src/api";
import { getAPIURL } from "src/utils";

export async function getSessionDetails({ sessionId }: { sessionId: string }) {
  return api.service("dashboard").get(getAPIURL("sessions"), { id: sessionId });
}
